import { Component, ChangeDetectionStrategy} from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'tooltip-component',
  template: ` <div style="border: solid;border-color: #6495ed;background: #ebebeb;">
  <div style="margin-top:3px;margin-left:3px;word-wrap: break-word;">
    <p>
      <span style="font-weight: bold;">Public Dashboard Name: </span> {{ data.dashboardName }}
    </p>
    <p>
    <span style="font-weight: bold;">Description: </span>
    {{ data.description }}
    </p>   
    </div>
  </div>`,
  styles: [
    `
      :host {
        position: absolute;
        width: 250px;
        height: 50px;
        pointer-events: none;
        transition: opacity 1s;        
      }
      :host.ag-tooltip-custom {
        top: 0px !important;
        right: 20px !important;
        left: auto !important;
      }
      :host.ag-tooltip-hiding {
        opacity: 0;
      }       
    `,
  ],
})
export class CustomTooltipRenderer implements ITooltipAngularComp {
  private params!: { color: string } & ITooltipParams;
  public data!: any;
  public color!: string;

  agInit(params: { color: string } & ITooltipParams): void {
    this.params = params;
    this.data = params.api!.getDisplayedRowAtIndex(params.rowIndex!)!.data;
    this.color = this.params.color || 'white';
  }
}
